import { NAME } from './constants';

export const INITIALIZE_VALUES = `${NAME}/INITIALIZE_VALUES`;

export const RESET = `${NAME}/RESET`;
export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE_PROPOSAL = `${NAME}/SAVE_PROPOSAL`;
export const SAVE_PROPOSAL_FAILURE = `${NAME}/SAVE_PROPOSAL_FAILURE`;
export const SAVE_PROPOSAL_SUCCESS = `${NAME}/SAVE_PROPOSAL_SUCCESS`;

export const SET_IS_OPEN_MODAL = `${NAME}/SET_IS_OPEN_MODAL`;
export const SET_MODE = `${NAME}/SET_MODE`;
